module.exports = __webpack_public_path__ + "bf9d1c22db07d5b5f16da003441c2245.png";